export const BOOKMAKER_NAMES_LOOKUP = {
  SB2: 'Sportsbet',
  BF: 'Betfair',
  LB: 'LuxBet',
  SB5: 'SportsBetting',
  N: 'TAB NSW',
  TS_N: 'TAB Fixed NSW',
  V: 'TAB VIC',
  TS_V: 'TAB Fixed VIC',
  Q: 'UBET',
  TS_Q: 'TAB Fixed QLD',
  NZ: 'NZ TAB',
  BE: 'BetEasy',
  CB: 'Centrebet',
  BB2: 'BestBookies',
  TS2: 'TopSport',
  BT: 'Bet365',
  OB: 'TABTouch',
  WH: 'William Hill UK',
  LB2: 'Ladbrokes',
  LB2U: 'Ladbrokes UK',
  UB: 'Unibet',
  CB2: 'PlayUp',
  TB2: 'TopBetta',
  OP: 'Official Price',
  BV: 'BetVictor',
  SB6: 'SkyBet',
  CB3: 'Coral',
  BS3: 'BoyleSports',
  RB2: 'RaceBets',
  GT: 'Global Tote',
  ND: 'Neds',
  BB3: 'BlueBet',
  BB4: 'BBet',
  BD: 'Betdogs',
  RB3: 'Real Bookie',
  BD2: 'Bet Deluxe',
  DD: 'David Dwyer',
  PN: 'Pronet',
  WB2: 'Wishbet',
  CY: 'Caymanas Bet',
  BN: 'BetNation',
  TW: 'Tom Waterhouse',
  GSB: 'Get Set Bet',
  MB: 'Marantelli',
  PB5: 'Punt 123',
  OKE: 'Okebet',
  MN: 'Monmouth',
  BSB: 'BossBet',
  RB5: 'ReadyBet',
  SB3: 'SwiftBet',
  BB: 'BaggyBet',
  UC: 'UpCoz',
  MNB: 'MintBet',
  BETR: 'Betr',
  SC: 'SportChamps',
  FXC: 'FoxCatcher',
  ESB: 'EskanderBet',
  DBT: 'DiamondBet',
  BW3: 'BitWinning',
  TBT: 'ThunberBet',
  VPB: 'VIP Betting',
  BTE: 'Bet Estate',
  PWB: 'Play West Bet',
  CHB: 'ChaseBet',
  PBT: 'PremiumBet',
  B66: 'BET66',
  BL: 'BetLocal'
}

export const BOOKMAKER_SOURCE_LOOKUP = {
  sportsbet: 'SB2',
  luxbet: 'LB',
  sportsbetting: 'SB5',
  beteasy: 'BE',
  centrebet: 'CB',
  bestbookies: 'BB2',
  topsport: 'TS2',
  bet365: 'BT',
  williamhill: 'WH',
  ladbrokes: 'LB2',
  ladbrokesuk: 'LB2U',
  unibet: 'UB',
  playup: 'CB2',
  topbetta: 'TB2',
  officialprice: 'OP',
  betvictor: 'BV',
  skybet: 'SB6',
  coral: 'CB3',
  boylesports: 'BS3',
  racebets: 'RB2',
  neds: 'ND',
  bluebet: 'BB3',
  bbet: 'BB4',
  betdogs: 'BD',
  realbookie: 'RB3',
  betdeluxe: 'BD2',
  daviddwyer: 'DD',
  betmakers: 'BMSP',
  robwaterhouse: 'RW',
  do: 'SB2',
  picnicbet: 'SB2',
  uat: 'SB2',
  crossbet: 'SB2',
  texbet: 'SB2',
  zbet: 'SB2',
  mailbag: 'SB2',
  nztab: 'NZ',
  dimers: 'DM',
  pronet: 'PN',
  wishbet: 'WB2',
  caymanasbet: 'SB2',
  betnation: 'BN',
  tomwaterhouse: 'TW',
  getsetbet: 'GSB',
  punt123: 'PB5',
  marantelli: 'MB',
  okebet: 'OKE',
  betgold: 'BG',
  monmouth: 'MN',
  monmouthtech: 'MN',
  bossbet: 'BSB',
  readybet: 'RB5',
  swiftbet: 'SB3',
  baggybet: 'BB',
  upcoz: 'UC',
  mintbet: 'MNB',
  betr: 'BETR',
  sportchamps: 'SC',
  foxcatcher: 'FXC',
  eskanderbet: 'ESB',
  diamondbet: 'DBT',
  bitwinning: 'BW3',
  thunderbet: 'TBT',
  betestate: 'BTE',
  playwestbet: 'PWB',
  chasebet: 'CHB',
  premiumbet: 'PBT',
  bet66: 'B66',
  betlocal: 'BL'
}
